/* @flow */
import * as React from 'react';
import AdminSchoolTableBody from 'admin/components/AdminSchoolTableBody';
import CenteredLoadingIndicator from 'components/CenteredLoadingIndicator';
import gql from 'graphql-tag';
import { graphql } from 'react-apollo';
import { orderBy } from 'lodash';

type Props = {
  sort: string,
  query?: string,
  districtId: number,
  disabled: boolean,
  inGroupView?: ?boolean,
  schools: *,
  loading: boolean,
};

function sortedSchools(schools: *, sortKey: string) {
  return orderBy(schools, ['name'], [sortKey.split('_')[1]]);
}

class AdminSchoolTableBodyContainer extends React.Component<Props> {
  render() {
    const { loading, disabled, schools, inGroupView, sort } = this.props;
    if (loading) {
      return (
        <tbody>
          <td colSpan={99}>
            <CenteredLoadingIndicator />
          </td>
        </tbody>
      );
    }

    return (
      <AdminSchoolTableBody
        disabled={disabled}
        schools={sortedSchools(schools, sort)}
        inGroupView={inGroupView}
      />
    );
  }
}

const withSchools = graphql(
  gql`
    query AdminSchoolTableQuery($districtId: Int!, $query: String) {
      organizations(ids: [$districtId]) {
        uuid
        childOrganizations(query: $query) {
          uuid
          id
          name
          paidAt
          statistics {
            teacher_count
            subscriber_count
            class_count
            message_count
          }
        }
      }
    }
  `,
  {
    options: ({ districtId, query }) => ({
      variables: {
        districtId,
        query,
      },
    }),
    props: ({ data }) => {
      const { loading, organizations } = data;
      if (loading || !organizations) {
        return { loading };
      }

      const district = organizations[0];
      if (!district) {
        console.error('no district found!');
        return { schools: [] };
      }

      return {
        schools: organizations[0].childOrganizations,
      };
    },
  }
);

export { AdminSchoolTableBodyContainer };
export default withSchools(AdminSchoolTableBodyContainer);
